





















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class RadioSwitch extends Vue {
    @Prop() data!: any;

    visible = false;
    
    async updateValue(e: TextEvent) {
        await this.$store.dispatch(this.data.action, { key: this.data.key, value: (e.target as HTMLInputElement).value }, { root: true });
        this.updateVisible();
    }

    updateVisible() {
        this.visible = this.data.list[0].checked === true || this.data.list[2].checked === true;
    }

    mounted() {
        this.updateVisible();
    }
}
